var loadMore = {
    init: function () {
        // nothing to do
    },
    searchReq: '',
    click: function(button, callback) {
        var limit = $(button).data("limit");
        var url = $(button).data("request");
        var target = '#' + $(button).data("target");
        var pageCnt = $(button).data("pagecnt");
        pageCnt++;
        $(button).data("pagecnt", pageCnt);

        $(button).prop('disabled', true);

        if($(button).data("request-data")) {
            var data = $(button).data("request-data");
        } else {
            var data = {};
        }

        data.lazyLoad = '';
        data.limit = limit;
        data.searchReq = loadMore.searchReq;
        data.newbuild = true;
        data.page = pageCnt;

        console.log('data', data);

        $.ajax({
            url: url,
            method: $(button).data("method"),
            dataType: "json",
            data: data,
            success: function( resp ) {
                if(resp.data) {
                    if(resp.data.title && $(button).data('title-target')) {
                        $('#' + $(button).data('title-target')).html(resp.data.title);
                    }

                    if(pageCnt == 1) {
                        $(target).html(resp.data.html);
                    } else {
                        $(target).append(resp.data.html);
                    }
                    if(resp.data.more) {
                        $(button).prop('disabled', false);
                    } else {
                        $(button).hide();
                    }

                    if(typeof data.method === 'undefined' || data['method'] == 'get' || data['method'] == 'GET') {
                        loadMore.updateLocationUrl(data);
                    }

                    if(typeof callback === "function") {
                        callback(resp.data);
                    }
                } else {
                    console.log(resp);
                }
            }
        });
    },

    updateLocationUrl: function(data) {
        if (history.pushState) {
            var newurl = window.location.origin + window.location.pathname + '?' + $.param(data);;
            window.history.pushState({path:newurl},'',newurl);
        }
    }

}